module.exports = __webpack_public_path__ + "c60c073638ff11d6dfd3875eac0eb77c.MP3";